import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  info: {
    width: '85%',
    padding: '11px 10px 11px 10px',
    boxSizing: 'border-box',
  },
  title: {
    fontWeight: 400,
    color: '#666666',
  },
}));

const AddressInfo = ({ ...props }) => {
  const { title, addressText, locationText, primary } = props;
  const classes = useStyles();

  const titleMaker = (primaryAddress) => {
    return primaryAddress === 'true' ? `Dirección principal: ${title}` : title;
  };

  return (
    <div className={classes.info}>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="flex-start"
      >
        <Typography className={classes.title} variant="h4">
          {titleMaker(primary)}
        </Typography>
      </Box>
      <Typography variant="h4">{addressText}</Typography>
      <Typography variant="h4">{locationText}</Typography>
    </div>
  );
};

AddressInfo.propTypes = {
  title: PropTypes.string,
  addressText: PropTypes.string,
  locationText: PropTypes.string,
  primary: PropTypes.string,
};

export default React.memo(AddressInfo);
